import {DEFAULT_LANGUAGE_OPTION, LANGUAGES_OPTIONS, setLanguage} from '../localization/i18n.ts';
import {ListItemIcon, ListItemText, Menu, MenuItem} from '@mui/material';
import {NavButton} from '@apps-common/ui-components/NavBar/NavMenuButton';
import {useState} from 'react';
import {useTranslation} from 'react-i18next';

const flagImgStyle = {
  width: 20,
  height: 14,
  objectFit: 'cover' as const,
  flexShrink: 0,
  display: 'block',
};

export const ManualLanguageMenu: React.FC = () => {
  const {t, i18n} = useTranslation();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const selected =
    LANGUAGES_OPTIONS.find(option => option.value === i18n.language) ?? DEFAULT_LANGUAGE_OPTION;

  const handleSelect = (value: string): void => {
    setLanguage(value);
    setAnchorEl(null);
  };

  return (
    <>
      <NavButton
        title={t('language')}
        aria-label={t('language')}
        onClick={event => setAnchorEl(event.currentTarget)}
      >
        <img
          alt=""
          loading="lazy"
          src={`https://flagcdn.com/w20/${selected.code}.png`}
          srcSet={`https://flagcdn.com/w40/${selected.code}.png 2x`}
          style={flagImgStyle}
        />
      </NavButton>
      <Menu
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
        transformOrigin={{vertical: 'top', horizontal: 'right'}}
      >
        {LANGUAGES_OPTIONS.map(option => (
          <MenuItem
            key={option.value}
            selected={option.value === i18n.language}
            onClick={() => handleSelect(option.value)}
          >
            <ListItemIcon>
              <img
                alt=""
                loading="lazy"
                src={`https://flagcdn.com/w20/${option.code}.png`}
                srcSet={`https://flagcdn.com/w40/${option.code}.png 2x`}
                style={flagImgStyle}
              />
            </ListItemIcon>
            <ListItemText primary={option.label} />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
